import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { UsersService } from 'src/app/core/user/services/users.service';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.less']
})
export class ResetPasswordDialogComponent {

  form: FormGroup;

  hidePassword = true;
  hideConfirmation = true;
  errorMessage?: string;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    private usersService: UsersService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.form = this.fb.group({
      password: [
  '',
  [
    Validators.required,
    Validators.pattern(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{12,}$/
    )
  ]
],
      confirmation: ['', Validators.required]
    });
  }

  validate(): boolean {

    return (
      this.form.valid
      && this.form.value.password === this.form.value.confirmation
    );
  }

  submit(): void {

  this.errorMessage = undefined;

  this.usersService.resetUserPassword({
    identifier: this.data.identifier,
    password: this.form.value.password
  }).subscribe({

    next: () => {

      // ferme seulement si succès
      this.dialogRef.close(true);

    },

    error: err => {

      this.errorMessage =
        err?.error?.message ??
        'Une erreur est survenue.';

    }

  });

}

  cancel(): void {
    this.dialogRef.close();
  }
}